const injectHelperIntoTemplate = (template, helper) => {
  if (!helper || !template) return template;

  // Inject helper into triple-stash expressions unless they are block/closing tags
  let result = template.replace(/{{{([^{}]+)}}}/g, (match, inner) => {
    const trimmed = inner.trim();
    if (trimmed.startsWith('#') || trimmed.startsWith('/') || trimmed === 'else') return match; // skip block helpers and else
    return `{{{${helper} ${inner}}}}`;
  });

  // Inject helper into double-stash expressions (excluding triple) unless block/closing tags
  result = result.replace(/{{([^{}]+)}}(?!})/g, (match, inner) => {
    const trimmed = inner.trim();
    if (trimmed.startsWith('#') || trimmed.startsWith('/') || trimmed === 'else') return match; // skip block helpers and else
    return `{{${helper} ${inner}}}`;
  });

  return result;
};

export default injectHelperIntoTemplate;
